export default {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_BUTTON_LOADING(state, isButtonLoading) {
    state.isButtonLoading = isButtonLoading;
  },
  OPEN_ERROR_MODAL(state, isErrorModalOpened) {
    state.isErrorModalOpened = isErrorModalOpened;
  },
  OPEN_BIOMETRIC_MODAL(state, isBiometricModalOpened) {
    state.isBiometricModalOpened = isBiometricModalOpened;
  },
  OPEN_TERMS_MODAL(state, isTermsModalOpened) {
    state.isTermsModalOpened = isTermsModalOpened;
  },
  SET_ERRORS(state, errors) {
    state.errors = errors;
  },
  SET_ERROR_FIELDS(state, errorFields) {
    state.errorFields = errorFields;
  },
  RESET_ERROR_FIELDS(state) {
    state.errorFields = {};
  },
  SET_MODAL_BACK_TO_ROUTE(state, modalBackToRoute) {
    state.modalBackToRoute = modalBackToRoute;
  },
  SET_HAS_NOTIFICATION(state, hasNotification) {
    state.hasNotification = hasNotification;
  },
  SET_IS_WEB_VIEW(state, isWebView) {
    state.isWebView = isWebView;
  },
  SET_MODAL_TITLE(state, modalTitle) {
    state.modalTitle = modalTitle;
  },
  CLOSE_MODAL_QR_SCAN(state, isClose) {
    state.isQrScanClosed = isClose;
  },
  SET_QR_POINT_DATA(state, qrPointData) {
    state.qrPointData = qrPointData;
  },
  RESET_QR_POINT_DATA(state) {
    state.qrPointData = null;
  },
  SET_BACK_ROUTE_NAME(state, backRouteName) {
    state.backRouteName = backRouteName;
  },
  SET_IS_LINKAGE_VIEW(state, isLinkageView) {
    state.isLinkageView = isLinkageView;
  },
  SET_QR_ROUTE_DATA(state, qrRouteData) {
    state.qrRouteData = qrRouteData;
  },
  CLICK_OUT_SIDE(state, notClickOutside) {
    state.notClickOutside = notClickOutside;
  },
  SET_PAY_CAMERA_OPEN(state, isPayCameraOpened) {
    state.isPayCameraOpened = isPayCameraOpened;
  }
};
